import React, { Component } from 'react';
import Guest1 from './Containers/guest1';
import Guest2 from './Containers/guest2';
import Main from './Containers/main';
import logo from './logo.svg';
import './App.css';


class App extends Component {

  render() {

    return (

    <div className="App">
          <Main />
          <br/><br/>
          <Guest1/>
          <Guest2/>
      </div>
    );
  }
}

export default App;
